export default __webpack_public_path__ + "img/cCVCnIAh.866c93fa.svg";